import React from "react";
import "./style/images.css"; // Importa il file CSS
import aboutNecklace from "../../images/about-necklace-jpeg.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function AboutNecklace() {
	return (
		<LazyLoadImage
			src={aboutNecklace}
			alt="AboutImageNecklace"
			className="img-responsive"
			width="700"
			height={aboutNecklace.offsetHeight}
			effect="blur"
		/>
	);
}

export default AboutNecklace;